<script>
export default {
  name: 'RepositoryApp',
};
</script>

<template>
  <router-view :key="$route.path" />
</template>
